import React, {useEffect} from 'react';
import Header from '../../components/Header/Header';
import ServiceBody from './Body';
import Download from '../../components/download/Download';
import Footer from '../../components/footer/Footer';
import './Service.css'
import { useStateValue } from '../../stateprovider';


export default function Service() {
    const [{ menu }, dispatch] = useStateValue();

    useEffect(()=>{
        dispatch({
            type: "MENU",
            menu: false
        });
        dispatch({
            type:"ACTIVE_NAVIGAtION",
            navigation: 'services'
        });

    },[])
    return <div className='Service'>
        <Header />
        <div className={(menu === true) ? 'notDisplay' : 'display'} style={{paddingTop: 100 + 'px'}}>
            <ServiceBody />
            <div className='Service__Footer__Section'>
                <Download />
                <Footer /></div>
        </div>



    </div>
}